// ============================================================================
// 📭 EMPTYSTATE — Estado Vacío Reutilizable
// src/features/mensagens/components/lista/EmptyState.jsx
// ============================================================================

import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Inbox } from 'lucide-react';

const EmptyState = memo(({
  icon: Icon = Inbox,
  title = 'Nada aqui',
  description = '',
  action,
  size = 'md',
}) => {
  const sizes = {
    sm: { icon: 32, title: 'text-sm', desc: 'text-xs', container: 'gap-2' },
    md: { icon: 48, title: 'text-base', desc: 'text-sm', container: 'gap-3' },
    lg: { icon: 64, title: 'text-lg', desc: 'text-base', container: 'gap-4' },
  };

  const s = sizes[size] || sizes.md;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`flex flex-col items-center justify-center text-center p-6 ${s.container}`}
    >
      <div className="p-4 rounded-full bg-gray-100">
        <Icon size={s.icon} className="text-gray-400" strokeWidth={1.5} />
      </div>

      <div>
        <h3 className={`font-semibold text-gray-700 ${s.title}`}>
          {title}
        </h3>
        {description && (
          <p className={`text-gray-400 mt-1 max-w-[280px] ${s.desc}`}>
            {description}
          </p>
        )}
      </div>

      {action && (
        <button
          onClick={action.onClick}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-xl
                     bg-blue-500 text-white text-sm font-medium
                     hover:bg-blue-600 active:bg-blue-700
                     transition-colors shadow-sm"
        >
          {action.icon && <action.icon size={16} />}
          {action.label}
        </button>
      )}
    </motion.div>
  );
});

EmptyState.displayName = 'EmptyState';
export { EmptyState };
export default EmptyState;